import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-file-processing',
  templateUrl: './upload-file-processing.component.html',
  styleUrls: ['./upload-file-processing.component.css']
})
export class UploadFileProcessingComponent implements OnInit {

  @Input() process: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
